import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import {Picker} from "emoji-mart"
import styled from "styled-components"
import "emoji-mart/css/emoji-mart.css"

import {injectIntl} from "@irati/utils/lang"
import {Lato} from "../global/fonts"
import {brand, greys} from "../global/colors"

import {SUPPRESSED_LIST} from "./constants"

const HiddenBackground = styled.div`
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9;
`

const PickerWrapper = styled.div`
  position: absolute;
  width: calc(100% - 30px);
  z-index: 10;
  .emoji-mart {
    font-family: inherit;
    font-size: inherit;
    .emoji-mart-bar {
      background: ${greys.light};
      .emoji-mart-anchor {
        padding: 10px 4px;
      }
    }
    .emoji-mart-search input {
      font-size: inherit;
    }
    .emoji-mart-scroll {
      height: 190px;
    }
    .emoji-mart-category-label span {
      ${Lato}
      font-size: "14px";
    }
    .emoji-mart-preview {
      display: none;
    }
  }
`

class FullEmojiPicker extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    onSelect: PropTypes.func,
    togglePickerModal: PropTypes.func.isRequired
  }

  static defaultProps = {
    onClick: () => {},
    onSelect: () => {}
  }

  state = {
    hover: false
  }

  handleMouseOut = () => this.setState({hover: false})
  handleMouseOver = () => this.setState({hover: true})

  render() {
    const {formatMessage, onClick, onSelect, togglePickerModal} = this.props

    return (
      <Fragment>
        <HiddenBackground onClick={(e) => {
          e.stopPropagation()
          togglePickerModal()
        }} />
        <PickerWrapper>
          <Picker
            color={brand.default}
            i18n={{
              categories: {
                activity: formatMessage({id: "platform.emojiPicker.categories.activity"}),
                custom: formatMessage({id: "platform.emojiPicker.categories.custom"}),
                flags: formatMessage({id: "platform.emojiPicker.categories.flags"}),
                foods: formatMessage({id: "platform.emojiPicker.categories.foods"}),
                nature: formatMessage({id: "platform.emojiPicker.categories.nature"}),
                objects: formatMessage({id: "platform.emojiPicker.categories.objects"}),
                people: formatMessage({id: "platform.emojiPicker.categories.people"}),
                places: formatMessage({id: "platform.emojiPicker.categories.places"}),
                recent: formatMessage({id: "platform.emojiPicker.categories.recent"}),
                search: formatMessage({id: "platform.emojiPicker.categories.search"}),
                symbols: formatMessage({id: "platform.emojiPicker.categories.symbols"})
              },
              notfound: formatMessage({id: "platform.emojiPicker.notfound"}),
              search: formatMessage({id: "platform.emojiPicker.search"}),
              skintext: formatMessage({id: "platform.emojiPicker.skintext"})
            }}
            emoji={null}
            emojisToShowFilter={(emoji) => !SUPPRESSED_LIST.includes(emoji.short_names[0])}
            onClick={onClick}
            onSelect={onSelect}
            style={{
              width: "100%"
            }}
            title={null} />
        </PickerWrapper>
      </Fragment>
    )
  }
}

export default injectIntl(FullEmojiPicker)
